// MiniWebSiteSkeleton.js
import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import MiniWebSessionCardSkeleton from '../../components/MiniWebSessionCard/MiniWebSessionCardSkeleton';
import { getGridSx } from './MiniWebSite';

export default function MiniWebSiteSkeleton() {
  const gradientBackground = 'linear-gradient(270deg, rgba(219, 219, 219, 0.05) 0%, #DBDBDB 50%)';
  return (
    <Grid
      container
      display="flex"
      sx={{
        background: 'linear-gradient(180deg, #FFFFFF 0%, #FFEEE7 100%)',
        minHeight: '100vh',
        padding: '16px',
        gap: '36px',
      }}
      alignItems="center"
      justifyContent="center"
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        mt={5}
        sx={{ gap: '32px', width: '100%' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <Skeleton
            variant="circular"
            width={130}
            height={130}
            sx={{ background: gradientBackground }}
          />

          <Skeleton
            width={278}
            height={24.5}
            sx={{ borderRadius: '35px', background: gradientBackground }}
          />

          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '10px',
              maxWidth: '300px',
            }}
          >
            <Skeleton
              width={113}
              height={24}
              sx={{ borderRadius: '100px', background: gradientBackground }}
            />
            <Skeleton
              width={84}
              height={24}
              sx={{ borderRadius: '100px', background: gradientBackground }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <Skeleton
            width={286}
            height={14.88}
            sx={{ borderRadius: '100px', background: gradientBackground }}
          />
        </Box>

        <Box sx={getGridSx(2)}>
          <MiniWebSessionCardSkeleton />
          <MiniWebSessionCardSkeleton />
        </Box>
      </Grid>
    </Grid>
  );
}
